export default {
  case: 'case',
  legis: 'legis',
  other: 'other',
  regulations: 'Regulations',
  ordinances: 'Ordinances',
}